/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MedicineCategoryApi } from '../api/medicinecategory.api';
import { switchMap, map } from 'rxjs/operators';
import { MedicineCategoryData, MedicineCategory } from '../../../interfaces/masters/medicinecategory';

@Injectable()
export class MedicineCategoryService extends MedicineCategoryData {

  constructor(private api: MedicineCategoryApi) {
    super();
  }


  list(): Observable<MedicineCategory[]> {
    return this.api.list();
  }

  getById(url:string): Observable<MedicineCategory>{
      return this.api.getById(url);
  }

  create(url: string, data:MedicineCategory): Observable<MedicineCategory> {
    return this.api.add(url,data);
  }

  update(url: string, data:MedicineCategory): Observable<MedicineCategory> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
  //uploadfromexcel
  postData(url: string, data:any[]): Observable<any> {
    return this.api.addData(url,data);
  }
}
